module.exports = __webpack_public_path__ + "img/Sandburg.a1a1e48d.svg";